// Desc: Admin Overview page
import Layout from "../../../components/Layout";
import BreadCrumb from "../../../components/BreadCrumb";
import { httprequest } from "../../../data/api";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Grid } from "@mui/material";
import Modal from "../../../components/Modal";
import Table from "../../../components/Table/Table";
import { TableSearch } from "../../../components/Table/TableActions";
import VerticalLine from "../../../assets/images/verticallines.svg";
// import Badge from "../../../components/Badge";
import useStyles from "../styles";
import PageLoader from "../../../components/PageLoader";
import useWindowSize from "../../../hooks/useWindow";
import { Icon } from "@iconify/react/dist/iconify.js";
// import nosearch from "../../../assets/images/no-search.svg";
import TabContext from "@mui/lab/TabContext";
import Tabs from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Badge from "../../../components/Badge";
import Tab from "@mui/material/Tab";
import { useUserState } from "../../../context/UserContext";
// import NotFounditem from "../../error/NotFound";

const TERM_ENDPOINT = "/api/v1/school-plan/terms";

const GET_SESSIONS = "/api/v1/school-plan/session";
const CLASSES_ENDPOINT = "/api/v1/class";
const TEACHER_CLASS_ENDPOINT = "/api/v1/teacher/classes";
const SCHOOL_TEST_AUDITS = "/api/v1/ca-test/audit-logs";
const OBTAINABLE_SCORE = "/api/v1/obtainable-score";

const TestAudit = () => {
//   const navigate = useNavigate();
  const classes = useStyles();
  const { userRole } = useUserState();
  const [classesData, setClassData] = useState([]);
  const [activeSession, setActiveSession] = useState([]);
  const [currentRow, setCurrentRow] = useState([]);
  const [anAuditDetail, setAnAuditDetail] = useState([]);
  const [obtainablescore, setObtainableScore] = useState([]);
  const [searchAuditDetail, setSearchAuditDetail] = useState([]);
  // const [selectedSession, setSelectedSession] = useState("");
  const [value, setValue] = useState("");
  const [allSessions, setAllSessions] = useState([]);
  const [aselectedTerm, setASelectedTerm] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const [itemModal, setItemModal] = useState(false);
  const [allCAAudits, setCaAudits] = useState([]);
  const [allAuditLog, setCaAuditLogs] = useState([]);
  const [selectedSessionTerms, setSelectedSessionTerms] = useState([]);
  const [filterStatus, setFilterStatus] = useState("");
  const [getIsLoading, setGetIsLoading] = useState(false);
  const [getIsLogsLoading, setGetIsLogsLoading] = useState(false);
  const [getIsLogsDetailsLoading, setGetIsLogsDetailsLoading] = useState(false);
  const [activeRow, setActiveRow] = useState(null);
  const width = useWindowSize();
  const isMobile = width < 600;
  const isTeacher = userRole?.role_type === "employee";

  /**
 * @file A collection of functions for managing school terms, sessions, test audits, and related data.
 */

  /**
 * Fetches all terms for a given session and filters them by session ID.
 * @param {string} Session_ID - The ID of the session to filter terms by.
 */
  const getAllTerms = (Session_ID) => {
    httprequest
      .get(TERM_ENDPOINT)
      .then((res) => {
        setSelectedSessionTerms(res?.data?.data.filter((selected_term) => selected_term?.session_id === Session_ID));
      });
    // .catch(() => {});
  };

  /**
 * Handles tab change events.
 * @param {Event} event - The change event.
 * @param {*} newValue - The new tab value.
 */
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  /**
 * Fetches school audit data for a specific subject and class.
 * @param {string} subject_id - The ID of the subject.
 * @param {string} class_id - The ID of the class.
 * @param {Object} row - The row data associated with the audit.
 */
  const getSchoolAuditInfo = (subject_id, class_id, row) => {
    setCurrentRow(row);
    setGetIsLogsLoading(true);
    httprequest
      .get(`${SCHOOL_TEST_AUDITS}/${subject_id}/${class_id}`)
      .then((res) => {
        setCaAuditLogs(res?.data?.data);
        setGetIsLogsLoading(false);
      }).catch((err) => {
        setGetIsLogsLoading(false);
        toast.error(err?.response?.message);
      });
  };

  /**
 * Fetches detailed audit information for a specific subject and class.
 * @param {string} subject_id - The ID of the subject.
 * @param {string} class_id - The ID of the class.
 */
  const getSchoolAuditInfoDetails = (subject_id, class_id) => {
    setGetIsLogsDetailsLoading(true);
    httprequest
      .get(`${SCHOOL_TEST_AUDITS}/${subject_id}/${class_id}/details`)
      .then((res) => {
        setAnAuditDetail(res?.data?.data);
        setSearchAuditDetail(res?.data?.data);
        setGetIsLogsDetailsLoading(false);
      }).catch((err) => {
        setGetIsLogsDetailsLoading(false);
        toast.error(err?.response?.message);
      });
  };

  /**
 * Opens the item modal and fetches audit details for the selected row.
 * @param {Object} row - The row data to display in the modal.
 */
  const handleOpenItemMOdal = (row) => {
    setItemModal(!itemModal);
    getSchoolAuditInfoDetails(row?.subject?.id, row?.class?.id);
  };

  /**
 * Fetches school test audit data for a selected term.
 * @param {string} aselectedTerm - The ID of the selected term.
 */
  const getSchoolTest = (aselectedTerm) => {
    setGetIsLoading(true);
    httprequest
      .get(`${SCHOOL_TEST_AUDITS}?term_id=${aselectedTerm}`)
      .then((res) => {
        const firstItem = res?.data?.data?.[0];
        setCaAudits(res?.data?.data);
        setSearchResult(res?.data?.data);
        setGetIsLoading(false);
        if (firstItem) {
          setActiveRow(0);
          setCurrentRow(firstItem);
          getSchoolAuditInfo(firstItem?.subject?.id, firstItem?.class?.id, firstItem);
        }
      }).catch((err) => {
        setGetIsLoading(false);
        toast.error(err?.response?.message);
      });
  };

  /**
 * Handles row click events and fetches audit information for the selected row.
 * @param {number} index - The index of the clicked row.
 * @param {Object} row - The data of the clicked row.
 */
  const handleRowClick = (index, row) => {
    setActiveRow(index);
    getSchoolAuditInfo(row?.subject?.id, row?.class?.id, row);
  };

  /**
 * Fetches all available sessions and sets the active session.
 */
  const getAllSessions = async () => {
    try {
      const res = await httprequest.get(GET_SESSIONS);
      setAllSessions(res?.data?.data);
      setActiveSession(res?.data?.data?.find((active_session) => active_session?.current_session === true));
    } catch (err) {
      toast.error(err?.response?.message);
    }
  };

  /**
 * Fetches all classes, either for a teacher or all classes based on the isTeacher flag.
 */
  const getAllClasses = () => {
    // setIsPageFetching(true);
    const CLASS_ENDPOINT = isTeacher ? TEACHER_CLASS_ENDPOINT : CLASSES_ENDPOINT;
    httprequest
      .get(CLASS_ENDPOINT)
      .then((res) => {
        const physicalClasses = res?.data?.data;
        // setIsPageFetching(false);
        setClassData(physicalClasses);
      })
      .catch((err) => {
        toast.error(err?.response?.data);
      });
  };

  /**
     * Fetches all obtainable scores from the API
     */
  const getAllObtainableScores = () => {
    httprequest
      .get(OBTAINABLE_SCORE)
      .then((res) => {
        setObtainableScore(res?.data?.data?.find((obtainable) => obtainable?.session?.id === activeSession?.id) || []);
        setValue(res?.data?.data?.find((obtainable) => obtainable?.session?.id === activeSession?.id)?.ca[0]?.ca_type);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };

  /**
 * The currently active term in the current session.
 * @type {Object}
 */
  const active_term_session = activeSession?.terms?.find((found_active_term) => found_active_term?.is_current === true);

  /**
 * Handles session change events and fetches terms for the selected session.
 * @param {Event} e - The change event.
 */
  const handleSessionChange = (e) => {
    const Session_ID = e.target.value;
    // setASelectedSession(e.target.value);
    getAllTerms(Session_ID);
  };

  /**
 * Handles term change events and fetches school tests for the selected term.
 * @param {Event} event - The change event.
 */
  const handleTermChange = (event) => {
    const selectedTermId = event.target.value;

    setASelectedTerm(selectedTermId);
    getSchoolTest(selectedTermId);
  };

  /**
 * Filters data by class name.
 * @param {Event} e - The change event containing the filter value.
 */
  const handleFilterChange = (e) => {
    const { value } = e.target;
    setFilterStatus(value);

    // Filter guardians based on status when the filter is applied
    const filteredByStatus = value
      ? allCAAudits?.filter((data) => data?.class?.name?.toLowerCase() === value.toLowerCase()
      )
      : allCAAudits?.students;

    setSearchResult(filteredByStatus);
  };

  /**
 * Columns configuration for the main table.
 * @type {Array<Object>}
 */
  const columns = [
    {
      name: "Subject",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Subject</p>}
          {row?.subject?.name}
        </>
      )
    },
    {
      name: "Class",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Class</p>}
          {row?.class?.name || "--/--"}
        </>
      )
    },
    ...(
      Array.from(
        new Set(
          allCAAudits?.flatMap(audit => Object.keys(audit?.ca_counts || {})
          )
        )
      ).map((caKey) => ({
        name: caKey,
        selector: (row) => (
          <>
            {isMobile && <p className="mobile-styling">{caKey}</p>}
            {row?.ca_counts?.[caKey] ?? "--/--"}
          </>
        )
      }))
    ),
    {
      name: "",
      center: "true",
      sortable: false,
      cell: (row, index) => (
        <div key={index} className="table-action-container">
          <button className="table-action-icon" onClick={() => handleOpenItemMOdal(row)}>
            <Icon icon="fluent:eye-16-regular" />
          </button>
          <button
            onClick={() => handleRowClick(index, row)}
            className={`table-action-icon ${activeRow === index ? "delete-icon" : ""}`}
          >
            <Icon icon="iconamoon:question-mark-circle" width="20" height="20" />
          </button>
        </div>
      )
    }
  ];
  /**
 * Columns configuration for the audit details table.
 * @type {Array<Object>}
 */
  const auditdetailscolumns = [
    {
      name: "Test Title",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Test Title</p>}
          {row?.title}
        </>
      )
    },
    {
      name: "Date Updated",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Date Updated</p>}
          {row?.updated_at?.substring(0, 10) || row?.date_added || "--/--"}
        </>
      )
    },
    {
      name: "Status",
      center: true,
      cell: (row) => <Badge status={row.status?.toLowerCase()} />
    }
  ];

  /**
 * Filters the guardian table using name, email, and class.
 * @param {Event} e - The change event containing the search value.
 */
  const handleSearchStudent = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    const filteredByStatus = filterStatus
      ? allCAAudits?.filter((data) => data?.class?.name?.toLowerCase() === value.toLowerCase()
      )
      : allCAAudits;
    // --| Filter data by partial match onchange in the search input box
    const result = filteredByStatus?.filter((data) => valArray?.every(
      (word) => data?.class?.name
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
                          data?.subject?.name
                            ?.toLowerCase()
                            .includes(word.toLowerCase()) ||
                          data?.title
                            ?.toLowerCase()
                            .includes(word.toLowerCase()) ||
                            data?.ca_type
                              ?.toLowerCase()
                              .includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  /**
 * Filters the audit details table using title, status, and category.
 * @param {Event} e - The change event containing the search value.
 */
  const handleSearchCA = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = anAuditDetail?.filter((data) => valArray?.every(
      (word) => data?.title
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
                                    data?.status
                                      ?.toLowerCase()
                                      .includes(word.toLowerCase()) ||
                                    data?.category
                                      ?.toLowerCase()
                                      .includes(word.toLowerCase()) ||
                                      data?.status
                                        ?.toLowerCase()
                                        .includes(word.toLowerCase())
    )
    );
    setSearchAuditDetail(result);
  };

  /**
   * On mount, fetches all classes, sessions, and terms.
   * This ensures that the application has the necessary data to display.
   */
  useEffect(() => {
    getAllClasses();
    getAllSessions();
  }, []);

  /**
   * On mount renders all classes
   */
  useEffect(() => {
    if (active_term_session?.id) {
      setASelectedTerm(active_term_session?.id);
      getSchoolTest(active_term_session?.id);
    }
  }, [active_term_session]);

  /**
   * On page Mount set the selected term and make an endpoint call to get Test for a term
   */
  useEffect(() => {
    if (activeSession?.id) {
      // setSelectedSession(activeSession?.id);
      getAllTerms(activeSession?.id);
      getAllObtainableScores();
    }
  }, [activeSession]);

  return (
    <Layout children={
      <>
        <div className="breadcrumb-container">
          <div>
            <BreadCrumb
              link_one="/assessment"
              link_one_name="CA Tests"
              active="CA Audit Logs"
              description="See all CA information"
            />
          </div>
        </div>

        <div className="flex gap-10 align-items-end margin-top-5 margin-bottom">
          <div>
            {activeSession?.id && (
              <SelectGroup
                children={
                  <select
                    defaultValue={activeSession?.id}
                    onChange={handleSessionChange}
                    name="session"
                  >
                    <option value="">---Select---</option>
                    {allSessions?.map((sesh) => {
                      return (
                        <option key={sesh?.id} value={sesh?.id}>
                          {sesh?.session}
                        </option>
                      );
                    })}
                  </select>
                }
              />
            )}
          </div>
          <div>
            {active_term_session?.id && (
              <SelectGroup
                children={
                  <select onChange={handleTermChange} name="term" value={aselectedTerm}>
                    <option value="">---Select---</option>
                    {selectedSessionTerms?.map((data) => {
                      return (
                        <option key={data?.id} value={data?.id}>
                          {data?.term}
                        </option>
                      );
                    })}
                  </select>
                }
              />
            )}
          </div>
          <div>
            <SelectGroup
              children={
                <select onChange={handleFilterChange}>
                  <option value="">Class</option>
                  {classesData?.map((data) => {
                    return (
                      <option key={isTeacher ? data?.class?.id : data?.id} value={isTeacher ? data?.class?.name : data?.class_name}>
                        {isTeacher ? data?.class?.name : data?.class_name}
                      </option>
                    );
                  })}
                </select>
              }
            />
          </div>
        </div>
        <Grid container spacing={4}
          sx={{
            "@media (max-width: 1000px)": {
              flexWrap: "wrap-reverse"
            }
          }}
        >
          <Grid item lg={8} md={8} sm={12} xs={12}>
            <div className="left-container">
              <>
                {getIsLoading ? (
                  <PageLoader />
                ) : (
                  <Table
                    data={searchResult}
                    columns={columns}
                    subHeader={true}
                    pagination
                    subHeaderComponent={
                      <div className="action_div">
                        <TableSearch
                          placeholder="Search here..."
                          searchTableFunc={handleSearchStudent}
                        />
                        <div className="text-center gap-10 cursor-pointer">
                          {/* <div>
                    <SelectGroup
                      children={
                        <select name="type" onChange={handleFilterChange}>
                          <option value="">-- Item --</option>
                          <option value="active">Active</option>
                          <option value="inactive">Inactive</option>
                        </select>
                      }
                    />
                  </div> */}
                          {/* <div>
                        <SelectGroup
                          children={
                            <select name="type" onChange={handleFilterChange}>
                              <option value="">-- Fee Status --</option>
                              <option value="active">Active</option>
                              <option value="inactive">Inactive</option>
                            </select>
                          }
                        />
                      </div>
                      <div>
                        <SelectGroup
                          children={
                            <select name="type" onChange={handlePaymentFilterChange}>
                              <option value="">-- Payment Method --</option>
                              <option value="active">Bank Transfer</option>
                              <option value="inactive">Payment Gateway</option>
                            </select>
                          }
                        />
                      </div> */}
                        </div>
                      </div>}
                  />
                )}
              </>
            </div>
          </Grid>
          <Grid item lg={4} md={4} sm={12} xs={12}>
            <div className="right-container">
              <div className={classes.logtitle}><h4>{`${currentRow?.subject?.name || "--/--"} CA`}</h4></div>
              {getIsLogsLoading ? (
                <PageLoader />
              ) : (
                allAuditLog?.map((update, i) => {
                  const isLastItem = i === allAuditLog.length - 1;

                  return (
                    <div key={i}>
                      <div className="flex gap-10 align-items-center margin-bottom-10">
                        <Icon
                          icon="lets-icons:check-fill"
                          style={{ color: "#3FAC64", height: "32px", width: "32px" }}
                        />
                        <div className={classes.logdetails}>
                          <h5>{update?.message}</h5>
                          <p>{update?.date_added}</p>
                        </div>
                      </div>
                      {!isLastItem && (
                        <div className={classes.verticalline}>
                          <img src={VerticalLine} alt="" />
                        </div>
                      )}
                    </div>
                  );
                })
              )}
            </div>
          </Grid>
        </Grid>
        {/* View Log Option */}
        <Modal
          title="CA Details"
          subtitle={
            <div>
                You can view all the CA for the subject.
            </div>
          }
          modalContent={
            <>
              {getIsLogsDetailsLoading ? (
                <PageLoader />
              ) : (
                <div className="table-border">
                  <TabContext value={value}>
                    <div className="padding-left-16">
                      <Tabs
                        className="overide-tablist"
                        onChange={handleChange}
                        aria-label=""
                      >
                        {obtainablescore?.ca?.map((ca, i) => (
                          <Tab key={i} value={ca?.ca_type} label={ca?.ca_type} />
                        ))}
                      </Tabs>
                    </div>

                    {obtainablescore?.ca?.map((ca, i) => {
                      const filteredData = searchAuditDetail.filter((item) => item?.ca_type === ca?.ca_type);

                      return (
                        <TabPanel className="tabpanel-overide" key={i} value={ca?.ca_type}>
                          {getIsLogsDetailsLoading ? (
                            <PageLoader />
                          ) : (
                            <Table
                              data={filteredData}
                              columns={auditdetailscolumns}
                              subHeader={true}
                              pagination
                              subHeaderComponent={
                                <TableSearch
                                  placeholder="Search here..."
                                  searchTableFunc={handleSearchCA}
                                />
                              }
                            />
                          )}
                        </TabPanel>
                      );
                    })}
                  </TabContext>

                </div>
              )}
            </>
          }
          modalFooter={
            <>
            </>
          }
          isopen={itemModal}
          closeModal={handleOpenItemMOdal}
        />
        {/* <ToastContainer /> */}
      </>
    }
    />
  );
};

export default TestAudit;
